// ── 미팅지도 SVG 아이콘 컴포넌트 ─────────────────────────────────────────────

import React from 'react';

// 연필(편집) 아이콘 SVG
export function PencilIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
    </svg>
  );
}

// 복사 아이콘 SVG
export function CopyIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <rect x="5" y="3" width="8" height="10" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <rect x="3" y="5" width="8" height="10" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
